import React from 'react';
import {useStripe, useElements, CardElement} from '@stripe/react-stripe-js';
import { Button } from 'baseui/button';
import { toaster, ToasterContainer } from "baseui/toast";
import { Block } from 'baseui/block';

const options = {
    style: {
        base: {
            color: "#32325d",
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
                color: "#aab7c4",
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    }
};

const PaymentPortal = (props) => {
    const stripe = useStripe();
    const elements = useElements();
    const transactionDetails = props.transactionDetails;
    const onCompleted = props.onCompleted; // <-- Callback on successful payment

    const [allowSubmit, setAllowSubmit] = React.useState(true);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if(!stripe || !elements) return;


        // try {
        //     setAllowSubmit(false);
        //     const result = await stripe.confirmCardPayment(transactionDetails.client_secret, { // todo timeout for also error
        //         payment_method: {
        //             card: elements.getElement(CardElement),
        //             billing_details: {
        //                 name: 'CUSTOMER_FIRST CUSTOMER_LAST', //TODO do we need names here?
        //             },
        //         }
        //     });
        //
        //     if(result.error) {
        //         setAllowSubmit(true);
        //         toaster.negative(<>An error occured, please try again</>);
        //     } else {
        //         // There's a risk of the customer closing the window before callback
        //         // execution. Set up a webhook or plugin to listen for the
        //         // payment_intent.succeeded event that handles any business critical
        //         // post-payment actions.
        //         if(onCompleted) onCompleted();
        //         else toaster.positive(<>Payment successful!</>);
        //     }
        // } catch(e) {
        //     toaster.negative(<>An error occured, please try again</>);
        //     setAllowSubmit(true);
        // }
    }

    return (
        <ToasterContainer autoHideDuration={5000}>
            <Block style={{padding: "30px"}}>
                <CardElement options={options} />
            </Block>
            <Block style={{textAlign: "right"}}>
                <Button disabled={!allowSubmit} isLoading={!allowSubmit} onClick={e => handleSubmit(e)}>Confirm</Button>
            </Block>
        </ToasterContainer>
    );
}

export default PaymentPortal;